import { motion } from "framer-motion";

// Generic scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headlines (each line clipped by overflow-hidden)
export const MaskedLines = ({ lines, className = "", lineClassName = "", stagger = 0.12, initialDelay = 0.15 }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.08em]">
        <span
          className={`fetch-reveal-line block ${lineClassName}`}
          style={{ animationDelay: `${initialDelay + i * stagger}s` }}
        >
          {line}
        </span>
      </span>
    ))}
  </h1>
);
